import L from 'leaflet'
import { layerGroup } from './mapManager'

import { returnVueComponentElement } from './vueUtil'
import MarkerPopup from '../components/main/MarkerPopup.vue'
import { InfiniteScroll } from 'element-ui'

/**
 * 添加图标
 * @param {坐标} latlng 
 * @returns 
 */
export function plotMarker(latlng) {
    var el = document.createElement("div")
    el.innerHTML = `<img src="./static/icons/001.png" style="width:40px;height:40px"><div class="marker-text">marker</div>`
    var myIcon = L.divIcon({
        className: 'my-div-icon',
        html: el,
        bgPos: latlng,
        iconAnchor: [24, 40]
    })
    let opt = {
        icon: myIcon,
        iconUrl: './static/icons/001.png',
        title: 'title',
        description: '',
        time: new Date().getTime(),
        textColor: 'red'
    }
    let marker = L.marker(latlng, opt)
    layerGroup.addLayer(marker)

    let params={
        marker
    }
     //更新
     let con = returnVueComponentElement(MarkerPopup, 'MarkerPopup', { params })
    var popup = L.popup()
        .setLatLng(latlng)
        .setContent(con)
    marker.bindPopup(popup, { offset: [0, -40] })
    return marker
}



// WEBPACK FOOTER //
// ./src/util/plotMarker.js